// TEMPORARY dev harness — renders the preview idle/boot state in isolation so
// it can be reviewed without a live sandbox. Delete this file + its route.
import { PreviewLoadingCarousel } from '~/components/workbench/Preview';

export default function DevPreviewIdle() {
  return (
    <div className="w-full h-screen bg-page flex items-center justify-center p-6">
      <div className="w-full max-w-[1120px] h-[660px] rounded-2xl border border-hairline bg-surface overflow-hidden">
        <PreviewLoadingCarousel />
      </div>
    </div>
  );
}
